export enum ParameterTypeEnum {
    ACTUALIZACION_USDT = 'ACTUALIZACION_USDT',
    ACTUALIZACION_VES = 'ACTUALIZACION_VES',
    CORREOS_AUTORIZADOS ='CORREOS_AUT',
    // Lista aparte de operadores habilitados SOLO para abonar (crédito manual)
    // saldo USDT en "Movimientos de usuario". OJO: a diferencia de CORREOS_AUT
    // (que guarda hashes), este parámetro guarda los correos en TEXTO PLANO,
    // separados por coma/espacio. El front compara el email de Cognito directo.
    CORREOS_AUT_USDT = 'CORREOS_AUT_USDT',
    FIAT_AUTOMATICO ='FIAT_AUTOMATICO',
    TIPO_DE_TASA_OPERADOR_WALLET = 'TIPO_DE_TASA_OPERADOR_WALLET',
    VALOR_RATE_MANUAL ='VALOR_RATE_MANUAL',
    // Cuentas de trabajo dedicadas a los rails de pago automático VES.
    // Se usan para bloquear visualmente (en pending-transactions) las tx
    // que N58 / Banco Plaza están procesando y que aún figuran POR_PROCESAR.
    CUENTA_TRABAJO_N58 = 'CUENTA_TRABAJO_N58',
    CUENTA_TRABAJO_BANCO_PLAZA = 'CUENTA_TRABAJO_BANCO_PLAZA',
}

export enum ParameterValueEnum{
  MANUAL = 'MANUAL',
  AUTOMATICO = 'AUTOMATICO'
}
